<template>
    <main class="main sales" id="main">
        <div class="main_top_line">
            <div class="container">
                <div class="top_line_column">
                    <div class="m_tl_text">
                        <h1>Получи 100 рублей на телефон при любом заказе</h1>
                        <p>Введите адрес доставки <a  href="#">Пользовательское соглашение</a> </p>
                    </div>
                    <div class="m_tl_icons">
                        <a href="#"><div class="icon icon1"></div></a>
                        <a href="#"><div class="icon icon2"></div></a>
                        <a href="#"><div class="icon icon3"></div></a>
                        <a href="#"><div class="icon icon4"></div></a>
                        <!-- <div class="icon"></div>
                        <div class="icon"></div>
                        <div class="icon"></div>
                        <div class="icon"></div> -->
                    </div>
                    <div class="m_tl_text">
                        <h1>Получи 200 рублей за регистрацию на бонусный счёт</h1>
                    </div>
                    <button class="green_btn">Получить</button>
                </div>
            </div>
        </div>
        <!----------Section Sales------------->
        <section class="section s-sales">
            <div class="container">
                <div class="sales_cards">
                    <div class="sales_inner" v-for="(stock, index) in stocks" :key="index">
                        <div class="sales_header">
                            <img :src="stock.restaurant.logo" alt="">
                            <div class="sales_time">
                                    <countdown tag="h2" :time="new Date((stock.to).split('.')[2],(stock.to).split('.')[1]-1,(stock.to).split('.')[0]) - new Date()">
                                        <template slot-scope="props" v-if="props.days > 0">{{ props.days }} дней</template>
                                        <template slot-scope="props" v-else>{{ props.hours }}:{{ props.minutes }}:{{ props.seconds }}</template>
                                    </countdown>
                                <span>до конца акции</span>
                            </div>
                        </div>
                        <div class="sales_image">
                            <img :src="stock.photo" alt="">
                            <span>{{stock.text}}</span>
                        </div>
                        <div class="sales_bottom">
                            <p>{{stock.description}}</p>
                            <button type="button" class="menu_item_btn" @click="putInBasket(stock.product_id, stock.restaurant.id)">Получить</button>
                        </div>
                    </div>
                </div>
            </div>
            <!-------Show more(button)----------->
            <button type="button" class="menu_item_btn add">Показать еще<img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/restrunt_list/add_more.svg" alt=""></button>
        </section>
        <section class="section_b">
            <div class="container">
                <div class="title">
                    <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/restrunt_card/main/big_van_24.svg" alt="big_van_24">
                    <h1>Круглосуточная доставка еды</h1>
                </div>
                <p>
                    Служба доставки еды "ХОЧУ-ПОЕСТЬ.РФ" в городе {{city.name}} - это свыше 1000 блюд и напитков, которые привезут вам домой или в офис без наценок и дополнительной комиссии от лучших ресторанов Вашего города. Есть из чего выбрать! Вы видите то, что Вы заказываете, и точно знаете стоимость, которую нужно заплатить.
                </p>
            </div>
        </section>
    </main>
</template>

<script>
// import $ from 'jquery'
import countdown from '@chenfengyuan/vue-countdown'
import axios from '@/router/http'
export default {
  name: 'stocks',
  props: ['city', 'mapinit', 'geo', 'auth'],
  components: {countdown},
  data () {
    return {
      stocks: []
    }
  },
  created () {
    if (this.auth.uid) this.initAjax()
    else {
      let interval = setInterval(() => {
        if (this.auth.uid) {
          clearInterval(interval)
          this.initAjax()
        }
      }, 100)
    }
  },
  methods: {
    initAjax () {
      axios.get('https://lk.when-hungry.com/mobile/categories-get?uid=' + this.auth.uid).then(response => {
        this.stocks = response.data.stocks
      })
    },
    putInBasket (id, rest) {
      if (this.$root.geo.address && this.$root.geo.lat2 && this.$root.geo.lng2) {
        var formData = new FormData()
        formData.append('id', id)
        formData.append('uid', this.$root.auth.uid)
        axios.post('https://lk.when-hungry.com/mobile/put-in-basket',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        ).then(response => {
          this.$root.basketUpdate = 1
          this.$router.push({ name: 'restaurant', params: { id: rest } })
        })
      } else this.$root.modals = 'selectCity'
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/stocks.vue